import { Flex } from "Element/Flex";
import React from "react";
import { StyledHeroText } from "../styled";
import { roadmap } from "./roadmap";
import {
  ContainerContent,
  ContainerLeft,
  ContainerRight,
  ContentWrapper,
  RoadmapWrapper,
  StyledUl,
  Timeline,
} from "./styled";

const Roadmap = () => {
  return (
    <RoadmapWrapper>
      <StyledHeroText style={{ marginBottom: 96 }}>OUR ROADMAP</StyledHeroText>
      <Timeline>
        {roadmap.map((list, idx) =>
          idx % 2 === 0 ? (
            <ContainerLeft key={idx} ok={list.ok}>
              <ContainerContent idx={idx}>
                <ContentWrapper idx={idx} gap={16} flexDirection="column">
                  <h2>{list.date}</h2>
                  <StyledUl>
                    {list.desc.map((desc) => (
                      <li key={desc}>{desc}</li>
                    ))}
                  </StyledUl>
                </ContentWrapper>
                <img src={list.img} alt="" />
              </ContainerContent>
            </ContainerLeft>
          ) : (
            <ContainerRight key={idx} ok={list.ok}>
              <ContainerContent idx={idx}>
                <img src={list.img} alt="" />
                <ContentWrapper idx={idx} flexDirection="column">
                  <h2>{list.date}</h2>
                  <StyledUl>
                    {list.desc.map((desc) => (
                      <li key={desc}>{desc}</li>
                    ))}
                  </StyledUl>
                </ContentWrapper>
              </ContainerContent>
            </ContainerRight>
          )
        )}
      </Timeline>
    </RoadmapWrapper>
  );
};

export default Roadmap;
